import styled from 'styled-components'

const H4 = styled.h4`
  color: ${props => props.theme.colors.darkGray};
  font-weight: 600;
`

export default H4
